export const _en = {
    updateDialog: {
        title: "Reflect the changes",
        body: {
            onlyThis: "On this instance only",
            allFromNow: "On all occurrences from this one onwards",
            all: "In all instances"
        },
        alert: "You must make a selection before submitting."
    },
    deleteDialog: {
        title: "Delete a session",
        body: {
            onlyThis: "On this instance only",
            allFromNow: "On all occurrences from this one onwards",
            all: "In all instances"
        },
        alert: "You must make a selection before submitting."
    },
    onRemoveRecurringAlert: "By confirming, you remove this activity from its initial recurrence. This action is irreversible."
};

export const _fr = {
    updateDialog: {
        title: "Répercuter les modifications",
        body: {
            onlyThis: "Sur cette occurrence seulement",
            allFromNow: "Sur toutes les occurrences à partir de celle-ci",
            all: "Sur toutes les occurrences"
        },
        alert: "Vous devez renseigner un choix avant de valider."
    },
    deleteDialog: {
        title: "Suppression d'une activité",
        body: {
            onlyThis: "Cette occurence seulement",
            allFromNow: "Toutes les occurences à partir de celle-ci",
            all: "Toutes les occurences"
        },
        alert: "Vous devez renseigner un choix avant de valider."
    },
    onRemoveRecurringAlert: "En validant, vous extrayez cette activité de sa récurrence initiale.<br>Cette action est irréversible."
};